import { Paragraph } from "@/components/atoms/Paragraph";
import { Picture } from "@/components/atoms/Picture";
import type { IConnectedAppAndProjectsPicProps } from "@/components/organisms/InstallApplicationDrawer/types";

const ConnectedAppAndProjectsPic = ({
  name = "",
  logoUrl,
}: IConnectedAppAndProjectsPicProps) => {
  return (
    <div className="flex flex-col gap-2 items-center">
      {logoUrl ? (
        <Picture src={logoUrl} width={88} height={88} alt={name} />
      ) : (
        <div className="w-[88px] h-[88px] flex items-center justify-center border rounded-2xl text-center">
          <Paragraph size="large" fontWeight="bold">
            {name?.charAt(0)?.toUpperCase()}
          </Paragraph>
        </div>
      )}
      <Paragraph>{name}</Paragraph>
    </div>
  );
};

export default ConnectedAppAndProjectsPic;
